import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { BUTTON_BASE_RESET_CSS } from '@pkg/components/Sections/Profile/Buttons';
import { iconSize, styledMedia, styledTypography } from '@pkg/primitives';

export const StyledLink = styled(Link)`
    ${styledTypography.allianceBase};
    flex-direction: row;
    align-items: center;
    margin: 5px 0 10px;
    width: max-content;
    font-weight: 700;
    display: flex;
    gap: 5px;
    &:hover {
        opacity: 0.8;
    }
`;
export const StyledToggleHeading = styled.button`
    ${BUTTON_BASE_RESET_CSS};
    width: 100%;
    justify-content: flex-start;
    margin: 10px 0;
    &:hover {
        text-decoration: underline white;
    }
`;

export const IconWrapper = styled.div`
    ${styledMedia.iconWrapper};
    width: ${iconSize.smaller}px;
    height: ${iconSize.smaller}px;
`;

export const CustomIconWrapper = styled.div`
    display: flex;
    height: 20px;
    width: 20px;
    justify-content: center;
    align-items: center;
`;
export const ResetButton = styled.button`
    ${BUTTON_BASE_RESET_CSS};
`;

export const SearchWrapper = styled.div`
    margin-top: 20px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    gap: 14px;
    width: 100%;
`;

export const Code = styled.code`
    background: ${({ theme }) => theme.shades.white[15]};
    color: ${({ theme }) => theme.colors.green};
    border-radius: 6px;
    padding: 3px;
    font-weight: 600;
    font-family: 'Lucida Console', 'Liberation Mono', 'DejaVu Sans Mono', 'Bitstream Vera Sans Mono', 'Courier New',
        serif;
`;
